import { Message } from 'element-ui'
import { isEmpty, isObject } from 'lodash'
import Cookies from 'js-cookie'

/**
 * 提示信息
 * @param {string} message 提示信息
 * @param {string} type 提示类型，默认error，可选值：success, error
 */
export function tipMessage(message = '未知异常，请联系管理员', type = 'error') {
  Message({
    message: message,
    type: type,
    showClose: true,
    duration: 3 * 1000
  })
}

/**
 * 节流函数，连续触发事件但是在 n 秒中只执行一次函数
 * @param {*} func 要执行的函数
 * @param {*} wait 等待的时间
 */
export function throttle(func, wait) {
  let previous = 0
  return function() {
    const now = Date.now()
    const context = this
    const args = arguments
    if (now - previous > wait) {
      func.apply(context, args)
      previous = now
    }
  }
}

// 将账号按银行卡方式分隔，4个一组
export function bankCardFilter(cardNumber) {
  return cardNumber.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
}

/**
 * 字符串货币格式化
 * @param {string} numStr 数字字符串，可带小数
 */
export function strToThousands(numStr) {
  if (numStr == null || numStr == undefined) return numStr
  return numStr.toString().replace(/\d+/, function(n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ','
    })
  })
}

/**
 * 将query参数添加到url中 并 返回新的url，默认会携带上ac
 * @param oldUrl {String} 原url
 * @param queryObj {Object} 需要增加的query参数
 * @param needAC {Boolean} 是否需要自动携带ac
 * @return {String} 新url
 */
export function addQueryToUrl(oldUrl, queryObj = {}, needAC = true) {
  const ac = Cookies.get('X-JCZH-AC')
  queryObj = Object.assign(
    {},
    queryObj,
    needAC && ac ? { 'x-jczh-ac': ac } : {}
  )
  if (!oldUrl || isEmpty(queryObj)) return oldUrl

  const tempUrl = oldUrl.split('#')[0] || ''
  const hashUrl = oldUrl.split('#')[1] || ''
  const mainUrl = tempUrl.split('?')[0] || ''
  const queryUrl = tempUrl.split('?')[1] || ''

  let queryUrlObj = {}
  queryUrl.split('&').forEach(value => {
    if (!value) return

    const temp = value.split('=')
    queryUrlObj[temp[0]] = temp[1]
  })
  queryUrlObj = Object.assign({}, queryUrlObj, queryObj)

  const queryList = Object.keys(Object.assign({}, queryUrlObj, queryObj))
    .filter(key => {
      if (isObject(queryUrlObj[key])) {
        return !isEmpty(queryUrlObj[key])
      }
      return !!queryUrlObj[key]
    })
    .map(key => {
      if (isObject(queryUrlObj[key])) {
        return `${key}=${JSON.stringify(queryUrlObj[key])}`
      }
      return `${key}=${queryUrlObj[key]}`
    })

  let newUrl = mainUrl
  if (queryList.length) {
    newUrl = `${newUrl}?${queryList.join('&')}`
  }
  if (hashUrl) newUrl = `${newUrl}#${hashUrl}`

  return newUrl
}

/**
 * 跳转至云采购门户公告页
 */
export function toPortalNotice({ noticeId = '', noticeUrl = '' }) {
  // 防止当前页面有beforeunload的阻拦
  window.onbeforeunload = null
  const url = noticeId
    ? process.env.VUE_APP_PORTAL_URL + '/project/notice/' + noticeId
    : noticeUrl
  window.open(url, '_blank')
}

/**
 * 前往标前狗相应页面
 */
export function toBiddogPage(routePath) {
  const url = process.env.VUE_APP_BIDDOG_URL + routePath
  window.open(url, '_target')
}
